import Vue from 'vue'
import Router from 'vue-router'

// 主入口
import index from '@/views/index'

// 以下是所有路由模块
import followUp from './followUp'
import bindInfo from './bindInfo'
import doorHelp from './doorHelp'
import message from './message'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    // 这个路由用作测试
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '首页',
        requireAuth: false,
        requireUserInfo: true
      }
    },
    ...followUp,
    ...bindInfo,
    ...doorHelp,
    ...message
  ]
})

let getQueryString = (name)=> {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

const self = Vue.prototype;
const openid = localStorage.getItem('openid');
const hasBinded = localStorage.getItem('hasBinded');
const code = getQueryString('code');
const hasOpenid = (openid)=>{
  if(openid=='null' || openid==null || openid=='undefined' || openid==''){
    return false
  }
  return true
}


// 根据openid获取病人的信息
let getPatientInfo = (openid,next) => {
  self.axios.get('/healths/patients/info',{
    params:{
      openId:openid
    }
  }).then((res)=>{
    let hasBinded = res.data.data.hasBinded;
    localStorage.setItem('hasBinded',hasBinded);
    self.store.state.hasBinded = hasBinded;
    if(hasBinded){
      let uuid = res.data.data.patientDto.uuid;
      localStorage.setItem('uuid',uuid);
      self.store.state.uuid = res.data.data.patientDto.uuid;
      next()
    }else{
      next()
    }
  })
}

// 根据code获取openid
let getOpenid = (code,next) => {
  self.axios.get('/wechats/users/openid',{
    params:{
      code:code
    }
  }).then((res)=>{
    if(res.data.code=='000000' && res.data.data){
      let openId = res.data.data.openId || localStorage.getItem('openid');
      localStorage.setItem('openid',openId);
      self.store.state.openid = openId;
      // 根据openid获取病人的信息
      getPatientInfo(openId, next);
    }else{
      next()
    }

  })
}


// 全局导航钩子
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  window.document.title = to.meta.title;
  if(to.meta.requireUserInfo && hasOpenid(openid)){
    // 根据openid获取病人的信息
    getPatientInfo(openid, next);
  }else{
    getOpenid(code, next);
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js